import { MarkerClientT, PoiContainerCollectionItemT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useState } from 'react';
import { useContext } from 'react';
import { AppContext } from '../../../../state/app.state';
import PoiInfo from '../../PoiInfo/PoiInfo';
import { calculateMarkerStyle, calculateMarkerTipForegroundStyle, calculateMarkerTipStyle, measureImage } from '../marker.helper';

type PoiMarkerBoxProps={
    previewPoi: PoiContainerCollectionItemT;
    poiMarker?: MarkerClientT;
};

const PoiMarkerBox: React.FC<PoiMarkerBoxProps> = ({ previewPoi, poiMarker }): ReactElement => {
    const { presentationState } = useContext(AppContext);
    const [imageDimensions] = useState(measureImage());

    return useObserver(() => (
        <div style={{ ...calculateMarkerStyle(poiMarker?.relativePosition, imageDimensions, !!previewPoi.image, poiMarker, presentationState?.zoomScale, (-(2 / (presentationState?.zoomScale || 2) * 60))),
            transform: `scale(${(2 / (presentationState?.zoomScale || 2)) * 0.45})` }}
        className={'bv-mapping-facts-label  bv-mapping-facts-label--poi'}>
            <div className="bv-poi-label-content bv-poi-label-content--poi">
                <PoiInfo previewPoi={previewPoi}/>
            </div>
        </div>
    ));
};


export default PoiMarkerBox;